var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    display: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-google",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1319 9.33487C18.1319 8.69553 18.0735 8.08027 17.9648 7.49023H9.30566V10.9789H14.2537C14.0406 12.1062 13.3927 13.0612 12.4192 13.7009V15.9636H15.3905C17.1292 14.3934 18.1319 12.0814 18.1319 9.33487Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30506 18.1489C11.7874 18.1489 13.8686 17.3414 15.3899 15.9638L12.4186 13.7011C11.5954 14.2422 10.542 14.5621 9.30506 14.5621C6.91033 14.5621 4.88374 12.9758 4.16069 10.8438H1.08887V13.1806C2.6016 16.1281 5.71082 18.1489 9.30506 18.1489Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16099 10.844C3.97711 10.3029 3.8727 9.72472 3.8727 9.13048C3.8727 8.53624 3.97711 7.95804 4.16099 7.41692V5.08008H1.08917C0.466623 6.29761 0.111328 7.67525 0.111328 9.13048C0.111328 10.5857 0.466623 11.9634 1.08917 13.1809L4.16099 10.844Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30506 3.69818C10.6549 3.69818 11.8669 4.15332 12.8198 5.04679L15.4569 2.46002C13.8643 1.00518 11.7832 0.111328 9.30506 0.111328C5.71121 0.111328 2.6016 2.13252 1.08887 5.07965L4.16069 7.41649C4.88374 5.28487 6.91072 3.69818 9.30506 3.69818Z",
    fill: "#EA4335"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.961d2299328450ef3e35b89c5516cb9c.svg";
export { ForwardRef as ReactComponent };